import * as React from "react";
import { forwardRef } from "react";
const SvgCustomArrowRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.6759 10.083H3.66675V11.9163H14.6759V14.6663L18.3334 10.9997L14.6759 7.33301V10.083Z", fill: "#62676E" }));
const ForwardRef = forwardRef(SvgCustomArrowRight);
export default ForwardRef;
